import type { AvailabilitySlot } from "../../shared/api/schedules";
import { fullSlotLabel } from "./slotOccupancy";
import { hhmm } from "./sessionWindow";

/** Trạng thái một thẻ buổi ở màn Tạo lịch hẹn, chế độ Theo buổi (#19956). */
export interface SessionCardState {
  /** Hết chỗ (lượt/buổi/phòng, lượt/phòng/ngày…): không bấm được. */
  blocked: boolean;
  /** Bác sĩ đang chọn không có ca trực giao với buổi: bấm được, nhưng bỏ chọn bác sĩ. */
  offDuty: boolean;
  /** Nhãn ngắn hiện dưới giờ của thẻ; null = buổi còn chỗ. */
  label: string | null;
}

/**
 * #19956 — trạng thái từng buổi, khoá theo giờ bắt đầu "HH:mm". Đã chọn bác sĩ: lấy từ lưới của bác
 * sĩ (`/doctors/{id}/availability`, đã tính giới hạn theo phòng + ca trực giao với buổi). Chưa chọn:
 * từ availability chung của ngày (`/booking/availability`, theo phòng đang chọn). Không tự đếm gì ở
 * đây — cùng nguồn với tầng ghi.
 */
export function sessionCardStates(
  doctorSlots: readonly AvailabilitySlot[] | null | undefined,
  daySessions:
    | readonly { startTime: string; full: boolean; reason?: string | null }[]
    | null
    | undefined,
): Map<string, SessionCardState> {
  const out = new Map<string, SessionCardState>();
  if (doctorSlots) {
    for (const s of doctorSlots) {
      const offDuty = s.doctorOnDuty === false;
      out.set(hhmm(s.startTime), {
        blocked: !s.available && !offDuty,
        offDuty,
        label: s.available ? null : (s.reason ?? "Hết chỗ"),
      });
    }
    return out;
  }
  for (const s of daySessions ?? []) {
    out.set(hhmm(s.startTime), {
      blocked: s.full,
      offDuty: false,
      label: s.full ? fullSlotLabel(s.reason) : null,
    });
  }
  return out;
}
